import { Component } from '@angular/core';

@Component({
  selector: 'allas-encuentra-la-bateria-correcta',
  imports: [],
  template: `
    <main class="flex flex-col gap-2 mt-12">
      <!-- Titulo -->
      <h2
        class="text-2xl xl:text-4xl w-full text-center font-bold fs-condensed"
      >
        ENCUENTRA LA BATERÍA CORRECTA
      </h2>
      <!-- Subtitulo -->
      <p class="text-xs xl:text-sm text-center">
        Línea completa de baterías TAB para todo tipo de vehículos con garantía
        del fabricante.
      </p>

      <!-- Grid de Baterías -->
      <section class="grid grid-cols-1 xl:grid-cols-4 gap-8 xl:gap-4">
        @for (bateria of baterias; track bateria.title) {
        <article class="flex flex-col items-center justify-center">
          <img
            [src]="bateria.img"
            [alt]="bateria.title"
            class="w-auto object-contain h-[200px] xl:h-[300px]"
          />
          <span
            class="flex flex-col gap-2 items-center justify-center xl:-mt-12 xl:mr-12 text-center xl:text-left"
          >
            <span
              [innerHTML]="bateria.title"
              class="font-medium fs-condensed text-4xl text-appBlack"
            ></span>
            <p class="text-sm font-light">
              {{ bateria.mesesGarantia }} meses de Garantía
            </p>
          </span>
        </article>
        }
      </section>

      <!-- Subtitulo -->
      <span
        class="text-xl xl:text-3xl w-full text-center fs-condensed mt-6 -skew-x-12"
      >
        PARA VEHÍCULOS AMERICANOS, EUROPEOS, ASIATICOS
      </span>
    </main>
  `,
})
export class EncuentraLaBateriaCorrecta {
  baterias = [
    {
      img: '/images/services/diagnostico-instalacion-baterias/bateria-polar.webp',
      title: `POLAR`,
      mesesGarantia: 24,
    },
    {
      img: '/images/services/diagnostico-instalacion-baterias/bateria-agm-stop-n-go.webp',
      title: `AGM<br/>Stop&Go`,
      mesesGarantia: 72,
    },
    {
      img: '/images/services/diagnostico-instalacion-baterias/bateria-efb-stop-n-go.webp',
      title: `EFB<br/>Stop&Go`,
      mesesGarantia: 60,
    },
    {
      img: '/images/services/diagnostico-instalacion-baterias/bateria-5g.webp',
      title: `NANO<br/>5G`,
      mesesGarantia: 36,
    },
  ];
}
